import { serviceModel } from './service';
import { users } from '../lib/api/services';
import User from '../interfaces/User';

export default serviceModel<User>(users);
